// extracted by mini-css-extract-plugin
export default {"title":"RoomDetails_title__yW3C7","edit":"RoomDetails_edit__Ue8PA","cancel":"RoomDetails_cancel__yUlbl"};